import React from 'react';
import '../styles/GlowingBackground.css';

const GlowingBackground = () => {
  return (
    <div className="glowing-background">
      {/* Ambient glow */}
      <div className="ambient-glow"></div>
      
      {/* Tech lines */}
      <div className="tech-lines-container">
        <div className="tech-line tech-line-1"></div>
        <div className="tech-line tech-line-2"></div>
        <div className="tech-line tech-line-3"></div>
        <div className="tech-line tech-line-4"></div>
        <div className="tech-line tech-line-5"></div>
        <div className="tech-line tech-line-6"></div>
      </div>
      
      {/* Glowing particles */}
      <div className="particle-container">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
        <div className="particle particle-6"></div>
      </div>
      
      {/* Grid overlay */}
      <div className="grid-overlay"></div>
    </div>
  );
};

export default GlowingBackground;